
export const baseURL = {
  // live: '/api/proxy/',
  // development: '/api/proxy/',
  live: 'https://api.shipez.ai/api/',
  development: 'https://api.shipez.ai/api/',
  local: '/api/proxy/',
  dashboardApi: 'https://pyapi.shipez.ai/api/pyproxy',
  AiBaseURL: 'https://pyapi.shipez.ai',
  // Python backend — client API error logs (POST/GET, no local files)

  // dashboardApi: 'http://localhost:8000/api/pyproxy',
  // AiBaseURL: 'http://localhost:8000'
}; 
